// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../Table';
import {
  INVOICES_TABLE_COLUMNS,
  INVOICE_HUB_TABLES,
  INVOICE_HUB_AUTOMATION_IDS,
} from '../../consts/consts';
import { useStore } from '../../../../../store';
import {
  mapDataForInvoicesTable, buildQueryString, scrollWebappToTop, hasInvoiceByExternalId,
} from '../../utils';
import { useFetchInvoices } from '../../hooks/useFetchInvoices';
import { InvoiceHubContext } from '../../contexts/InvoiceHubContext';
import { HUB_MODALS } from '../InvoiceHubModals';
import { getUrlParamValueByKey } from '../../../../../services/getUrlParamValueByKey';

export const UnpaidInvoices = () => {
  const outstandingInvoices = useStore(state => state.outstandingInvoices);
  const setOutstandingInvoices = useStore(state => state.setOutstandingInvoices);
  const outstandingPageNumber = useStore(state => state.outstandingPageNumber);
  const setOutstandingPageNumber = useStore(state => state.setOutstandingPageNumber);
  const setSearchParams = useStore(state => state.setSearchParams);
  const searchParams = useStore(state => state.searchParams);
  const setSelectedInvoice = useStore(state => state.setSelectedInvoice);
  const setError = useStore(state => state.setError);
  const setActiveModal = useStore(state => state.setActiveModal);
  const [hasMoreToFetch, setHasMoreToFetch] = useState<boolean>(true);
  const { t } = useTranslation();
  const { refetch: fetchInvoices, isFetching } = useFetchInvoices({
    onSuccess: async (data: any) => {
      if (data?.invoices?.length === 0) {
        setHasMoreToFetch(false);
      } else {
        setOutstandingInvoices(data.invoices, outstandingPageNumber > 1);
      }
    },
    onError: (e: any) => {
      setError(e);
      setActiveModal(HUB_MODALS.ERROR);
    },
    queryString: buildQueryString(INVOICE_HUB_TABLES.OUTSTANDING.name, outstandingPageNumber),
    tableName: INVOICE_HUB_TABLES.OUTSTANDING.name,
  });
  useEffect(() => {
    setTimeout(() => {
      scrollWebappToTop();
    }, 0);
  }, []);

  useEffect(() => {
    fetchInvoices();
  }, [outstandingPageNumber]);

  useEffect(() => {
    if (outstandingInvoices.length > 0) {
      const invoiceExternalId = getUrlParamValueByKey('id', searchParams) || '';
      if (invoiceExternalId && hasInvoiceByExternalId(outstandingInvoices, invoiceExternalId)) {
        setSelectedInvoice(invoiceExternalId);
        setActiveModal(HUB_MODALS.INVOICE_PAGE);
        setSearchParams('');
      }
    }
  }, [outstandingInvoices]);

  const contextValue = useMemo(() => ({
    fetchMoreInvoices: () => {
      if (hasMoreToFetch) {
        setOutstandingPageNumber(outstandingPageNumber + 1);
      }
    },
  }), [outstandingPageNumber]);
  const outstandingInvoiceRows = useMemo(() => mapDataForInvoicesTable(INVOICE_HUB_TABLES.OUTSTANDING.name, outstandingInvoices), [outstandingInvoices]);
  return (
    <InvoiceHubContext.Provider value={contextValue}>
      <Table
        name={INVOICE_HUB_TABLES.OUTSTANDING.name}
        title={`${t(INVOICE_HUB_TABLES.OUTSTANDING.title)} (${outstandingInvoiceRows?.length || 0})`}
        columns={INVOICES_TABLE_COLUMNS}
        data={outstandingInvoiceRows}
        testId={INVOICE_HUB_AUTOMATION_IDS.HUB_TABLE_OUTSTANDING}
        isLoading={isFetching && outstandingPageNumber === 1}
      />
    </InvoiceHubContext.Provider>
  );
};
